import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { timeFormat, dateFormatFull } from 'utils/FormatDate'

const Detail = ({
    show,
    handleClose,
    data,
    busName,
    date
}) => {
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">Detail Data</Modal.Title>
            <FalconCloseButton onClick={handleClose} variant="white" />
            </Modal.Header>
                <Modal.Body>
                    <h4>{busName}, Tanggan Operasi : {dateFormatFull(date)}</h4>
                    <Table bordered size="sm">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Nama</th>
                                <th>Sekolah</th>
                                <th>Naik</th>
                                <th>Turun</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data ? data.map((value, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{value.vcsiswa}</td>
                                            <td>{value.vcsekolah}</td>
                                            <td>{timeFormat(value.dtin)}</td>
                                            <td>{value.out ? timeFormat(value.out) : ''}</td>
                                        </tr>
                                    );
                                }) : <tr>
                                        <td colSpan={5} align="center">
                                            Data tidak tersedia
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

Detail.propTypes = {}

export default Detail;